import { render, staticRenderFns } from "./CytomineTable.vue?vue&type=template&id=06865d92&scoped=true&"
import script from "./CytomineTable.vue?vue&type=script&lang=js&"
export * from "./CytomineTable.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTable.vue?vue&type=style&index=0&id=06865d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06865d92",
  null
  
)

export default component.exports